const GrowthChart = require('./GrowthChart');

module.exports = GrowthChart;
